var   KEYS  = require('../../keys/Keys');
var   AXIOS = require('axios');

export {GetDevicesAsync as InvokeAsync , GetDevicesSync as InvokeSync}

async function GetDevicesAsync(LoginToken,Filter,LastKey,Limit)
{
    var ResetTablePromise = new Promise((resolve, reject) => {
        GetDevicesSync(LoginToken,Filter,LastKey,Limit,(response,error) => {
            if (error) {  
                try{ 
                    return reject(error.response.data.message);
                }catch(ex){
                    return reject('Unknown error');
                }
            }
            if(response.status==='fails'){
                reject(response.error);
            }else{
                resolve(null);
            }
        });
    });

    return await ResetTablePromise;
}

function GetDevicesSync(LoginToken,Filter,LastKey,Limit,Callback)
{
    AXIOS({
        headers:{
            'Content-Type': 'application/json',
            'x-api-key'   : KEYS.AWS_XKEY,
        },
        method : 'post',
        url    :'/Admin/GetDevices',                
        data  : {
            AppID     :KEYS.AWS_APPID,
            Filter    :Filter,
            LastKey   :LastKey,
            Limit     :Limit,
            LoginToken:LoginToken             
        },                                
    })
    .then((response)=>{
        Callback(response.data,null);
    },(error) => { 
        Callback(null,error + ' ');
    });
}
